import { ListGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";

import { PublicPclProduct } from "api/public/project/product/product.types";

const ConformanceClaimsCell = ({
  row: { product_id, protection_profiles },
}: {
  row: PublicPclProduct;
}) => {
  return (
    <ListGroup style={{ width: "100%", textAlign: "center" }}>
      {protection_profiles.map((pp) => {
        return (
          <OverlayTrigger
            key={`${product_id}-${pp.pp_id}`}
            placement="top"
            overlay={<Tooltip>{pp.pp_name}</Tooltip>}
          >
            <Link
              to={`/protectionprofiles/${pp.pp_id}`}
              className="text-decoration-underline"
              style={{ textUnderlineOffset: "3px" }}
            >
              <ListGroup.Item
                disabled
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "150px",
                  width: "100%",
                }}
              >
                {pp.pp_short_name || pp.pp_name}
              </ListGroup.Item>
            </Link>
          </OverlayTrigger>
        );
      })}
    </ListGroup>
  );
};

export default ConformanceClaimsCell;
